import styled from 'styled-components';
import {
  py, m, p, px
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import Grid from 'styled-components-grid';

export const StyledAdditionalBenefitsWrapper = styled.div``;

export const StyledCard = styled.div`
  ${p(3)};
  ${m(1)};
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${breakpoint('mobile', 'tablet')`
   ${py(2)};
   ${px(1)};
  `};
`;

export const StyledCardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledImageWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  img {
    width: 100%;
  }
  ${breakpoint('mobile', 'tablet')`
 max-width:100%;
 `}
`;

export const StyledDescription = styled.div`
  font-size: 18px;
  line-height: 1.5rem;
  text-align: center;
  ${p(2)};
  ${breakpoint('mobile', 'desktop')`
   font-size: 14px;
   line-height: 1.2rem;
   ${py(2)};
   ${px(1)};
 `}
`;

export const StyledGrid = styled(Grid)``;
export const StyledGridUnit = styled(Grid.Unit)`
  display: flex;
  align-items: center;
  justify-content: center;
  ${breakpoint('mobile', 'desktop')`
  &:nth-last-child(1) {
  display:none;
}
`};
`;
